<template>
	<div class="container-fluid p-0">
		<!-- Tab Navigation removed since we only have one tab now -->

		<!-- Content -->
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'AutoCampaignParent',
	computed: {
		showHeader() {
			// Don't show header on the main dashboard
			return this.$route.name !== 'autoCampaignHome'
		},
		showBackButton() {
			// Show back button if we're not on main routes
			return !['autoCampaignHome', 'autoCampaigns'].includes(this.$route.name)
		},
	},
	methods: {
		goBack() {
			this.$router.go(-1)
		},
	},
}
</script>

<style scoped>
.page-title {
	font-size: 2rem;
	font-weight: 600;
	color: #1f2937;
	margin-bottom: 0.5rem;
}

.back-button {
	padding: 0.5rem;
	color: #6b7280;
	border: none;
	background: none;
	font-size: 1.25rem;
	transition: color 0.3s ease;
}

.back-button:hover {
	color: #374151;
	background: none;
}

.nav-tabs {
	border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
	color: #6c757d;
	border: none;
	border-radius: 0;
	padding: 0.75rem 1rem;
	font-weight: 500;
	background: none;
	position: relative;
	transition: all 0.3s ease;
}

.nav-tabs .nav-link:hover {
	color: #495057;
	background-color: transparent;
	border-color: transparent;
}

.nav-tabs .nav-link.active {
	color: #495057;
	background-color: transparent;
	border-color: transparent;
}

.nav-tabs .nav-link.active::after {
	content: '';
	position: absolute;
	bottom: -1px;
	left: 0;
	right: 0;
	height: 2px;
	background-color: #0d6efd;
}

.btn {
	font-weight: 500;
	padding: 0.5rem 1rem;
	border-radius: 0.375rem;
}

.btn-outline-secondary {
	color: #6c757d;
	border-color: #6c757d;
}

.btn-outline-secondary:hover {
	color: #fff;
	background-color: #6c757d;
	border-color: #6c757d;
}

.btn-primary {
	background-color: #0d6efd;
	border-color: #0d6efd;
}
</style>
